<template>
    <div style="">
        <div v-if="isShowLanding" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: #0F060066; display: flex; flex-direction: column; justify-content: center; z-index: 100; backdrop-filter: blur(5px);">
            <div style="color: #fff; line-height: 24px; font-size: 20px; font-weight: 700; text-align: center;">앱에 접속하여 포지션 찾기를<br>이어서 진행해보세요!</div>
            <div @click="showMemberRegist" style="width: 290px; height: 44px; border-radius: 45px; margin: 0 auto; margin-top: 49px; background-color: #fff; color: #210f03; line-height: 44px; font-weight: 500; font-size: 14px; text-align: center;">이어서 진행하기</div>
        </div>
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="padding: 0 20px; overflow-y: scroll; overflow-x: hidden;">
            <div style="padding: 20px; padding-left: 17px; width: 50px; height: 50px; display: flex; justify-content: center; align-items: center; float: right;">
                <div @click="() => { $GlobalStore.closeLastModal() }"><img :src="require('@/assets/pro_img/white_x_btn.png')" style="width:18px; margin-right: -20px;"></div>
            </div>
            <div style="margin-top: 62px; margin-bottom: 18px; text-align: center; font-weight: 700; font-size: 24px;">{{ sentence[step].title }} Q{{ step }}</div>
            <div style="padding:0px 20px; min-height: 100px;">
                <div v-html="sentence[step].contents" style=" font-size:20px; font-weight:500;line-height:28px;text-align:center;"></div>
                <div v-if="step === sentenceCnt" style="text-align: center; color: #808080; font-size: 14px; margin-top: 4px;">(양발이면 모두 선택)</div>
            </div>
            <div v-if="step !== sentenceCnt" style="min-height: 250px; text-align: center;">
                <div :style="{ marginLeft: sentence[step].title === FIND_POSITION_PRO_TITLE.EYESIGHT ? '-40px' : '' }" style="position: relative; white-space: nowrap;" v-for="index in 46" :key="index">
                    <object v-if="index === step && sentence[step].title !== FIND_POSITION_PRO_TITLE.GAME_FLOW" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub_img_ani_unactive_${sentence[step].title}` : `step_sub_img_ani_active_${sentence[step].title}`" :data="require(`@/assets/pro_img/서브_${sentence[step].title}.svg`)" alt=""></object>
                    <object v-if="index === step" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_img_ani_unactive_${sentence[step].title}` : `step_img_ani_active_${sentence[step].title}`" :data="require(`@/assets/pro_img/${sentence[step].title}.svg`)" alt=""></object>
                    <object v-if="index === step && (sentence[step].title === FIND_POSITION_PRO_TITLE.HEALTH || sentence[step].title === FIND_POSITION_PRO_TITLE.BALL_CONTROL || sentence[step].title === FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT || sentence[step].title === FIND_POSITION_PRO_TITLE.EYESIGHT || sentence[step].title === FIND_POSITION_PRO_TITLE.HEIGHT)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub2_img_ani_unactive_${sentence[step].title}` : `step_sub2_img_ani_active_${sentence[step].title}`" :data="require(`@/assets/pro_img/서브2_${sentence[step].title}.svg`)" alt=""></object>
                    <object v-if="index === step && (sentence[step].title === FIND_POSITION_PRO_TITLE.BALL_CONTROL || sentence[step].title === FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT || sentence[step].title === FIND_POSITION_PRO_TITLE.EYESIGHT)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub3_img_ani_unactive_${sentence[step].title}` : `step_sub3_img_ani_active_${sentence[step].title}`" :data="require(`@/assets/pro_img/서브3_${sentence[step].title}.svg`)" alt=""></object>
                    <object v-if="index === step && (sentence[step].title === FIND_POSITION_PRO_TITLE.BALL_CONTROL || sentence[step].title === FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT || sentence[step].title === FIND_POSITION_PRO_TITLE.EYESIGHT)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub4_img_ani_unactive_${sentence[step].title}` : `step_sub4_img_ani_active_${sentence[step].title}`" :data="require(`@/assets/pro_img/서브4_${sentence[step].title}.svg`)" alt=""></object>
                    <object v-if="index === step && (sentence[step].title === FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT || sentence[step].title === FIND_POSITION_PRO_TITLE.EYESIGHT)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub5_img_ani_unactive_${sentence[step].title}` : `step_sub5_img_ani_active_${sentence[step].title}`" :data="require(`@/assets/pro_img/서브5_${sentence[step].title}.svg`)" alt=""></object>
                    <object v-if="index === step && (sentence[step].title === FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT)" style="transition: all 0.3s;" :class="scores[step] === 0 ? `step_sub6_img_ani_unactive_${sentence[step].title}` : `step_sub6_img_ani_active_${sentence[step].title}`" :data="require(`@/assets/pro_img/서브6_${sentence[step].title}.svg`)" alt=""></object>
                </div>
            </div>
            <div style="width: 100%;">
                <div style="display:flex;align-items: center; justify-content: space-between; gap: 12px;" v-if="step > 0 && step < sentenceCnt && step !== 42">
                    <div @click="setScore(1)" :class="[scores[step] === 1 ? 'active' : '']" class="common_btn_survey">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">매우<br><span style="white-space: nowrap; color: #210f03;">아니다</span></div>
                    </div>
                    <div @click="setScore(2)" :class="[scores[step] === 2 ? 'active' : '']" class="common_btn_survey">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">아니다</div>
                    </div>
                    <div @click="setScore(3)" :class="[scores[step] === 3 ? 'active' : '']" class="common_btn_survey">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">중간</div>
                    </div>
                    <div @click="setScore(4)" :class="[scores[step] === 4 ? 'active' : '']" class="common_btn_survey">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">그렇다</div>
                    </div>
                    <div @click="setScore(5)" :class="[scores[step] === 5 ? 'active' : '']" class="common_btn_survey">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;">매우<br><span style="white-space: nowrap; color: #210f03;">그렇다</span></div>
                    </div>
                </div>
                <div style="display:flex;align-items: center; justify-content: center; gap: 60px; " v-if="step === 42">
                    <div class="round_wrap" @click="setScore(5)">
                        <div class="round" style="width:50px; height:50px;"></div>
                        <div class="inner_round orange_background" :class="[scores[step] === 5 ? 'active' : '']"></div>
                        <div style="">그렇다</div>
                        <!-- <div style="position:absolute; left:5px; top:65px;width:60px; font-weight: 500; font-size:16px; color: #101014;">그렇다</div> -->
                    </div>
                    <div class="round_wrap" @click="setScore(1)">
                        <div class="round blue" style="width:50px; height:50px;"></div>
                        <div class="inner_round orange_background" :class="[scores[step] === 1 ? 'active' : '']"></div>
                        <!-- <div style="position:absolute; left: 0px; top:65px;width:60px;  font-weight:500; font-size:16px; color:#101014">그렇지 않다</div> -->
                    </div>
                </div>
                <div v-if="step === 42" style="display: flex;width: 100%; justify-content: center; gap: 80px; padding: 20px 0; font-weight: 500;">
                    <div style="">그렇다</div>
                    <div style="margin-right: -14px;">그렇지 않다</div>
                </div>
                <div style="display:flex; justify-content: center; gap: 68px; align-items: center; padding:20px;" v-if="step === sentenceCnt">
                    <div style="text-align: center;" @click="setFootScore(1)">
                        <div style="margin-bottom: 16px; font-weight: 500; color: #fff;">왼발</div>
                        <div>
                            <img style="width: 90px;" :src="leftFoot ? require('@/assets/pro_img/left-foot-on.png') : require('@/assets/pro_img/left-foot-off.png')" alt="">
                        </div>
                    </div>
                    <div style="text-align: center;" @click="setFootScore(3)">
                        <div style="margin-bottom: 16px; font-weight: 500; color: #fff">오른발</div>
                        <div>
                            <img style="width: 90px;" :src="rightFoot ? require('@/assets/pro_img/right-foot-on.png') : require('@/assets/pro_img/right-foot-off.png')" alt="">
                        </div>
                    </div>
                </div>
                <div style="height:16px; background-color: #ededed; border-radius:50px;width:100%;position:relative; overflow:hidden; margin-top: 40px;">
                    <div style="position:absolute; left:0px;background-color:var(--color-main);height: 100%;  border-radius:4px; transition: all 0.2s;" :style="{ width: parseInt((step) / sentenceCnt * 100) + '%' }"></div>
                </div>
            </div>
        </div>
        <!-- <div style="padding: 20px">
            <div style="text-align:center; display: flex; gap: 20px;">
                <div @click="prevStep" v-if="step !== 1" class="prev_btn">
                    <div style="color: #fff;">이전</div>
                </div>
                <div v-if="step !== sentenceCnt && activeBtn" class="next_btn" @click="next(scores[step + 1])">다음</div>
                <div v-if="step === sentenceCnt" class="result_btn" @click="showResult">결과 보기</div>
            </div>
        </div> -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 8px; padding: 0 20px;">
            <div>
                <img style="width: 56px;" :src="require('@/assets/img/soccerhow_orange.png')" alt="">
                <div style="margin-top: 4px; font-size: 10px; font-weight: 500; line-height: 12px; color: #606060;">포지션 찾기 Pro</div>
            </div>
            <div style="flex-basis: 55%; display: flex; gap: 12px;" v-if="step !== sentenceCnt">
                <div @click="prevStep" v-if="step >= 2" style="background-color: #ededed; flex: 1;" class="next_btn">이전</div>
                <div style="flex: 1;" class="next_btn" @click="next(scores[step + 1])">다음</div>
            </div>
            <div style="display: flex; gap: 12px; flex-basis: 55%;" v-else>
                <div @click="prevStep" v-if="step >= 2" style="background-color: #ededed; flex: 1;" class="next_btn">이전</div>
                <div class="next_btn" @click="showResult">결과 보기</div>
            </div>
        </div>
    </div>
</template>

<script>
import { FIND_POSITION_PRO_TITLE } from '@/Constants'
import ResponseCode from '../../ResponseCode'
import axios from 'axios'
import moment from 'moment'
import MercenaryHeader from '@/components/common/MercenaryHeader'

export default {
    name: 'MyPositionProMain',
    props: {
        is_free: {
            type: Boolean,
            default: false
        },
        isLanding: {
            type: Boolean,
            default: false
        }
    },
    components: { MercenaryHeader },
    data() {
        return {
            step: 1,
            // step: 41,
            FIND_POSITION_PRO_TITLE: FIND_POSITION_PRO_TITLE,
            scores: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ],
            sentence: [
                '',
                { key: 1, group_key: 1, title: FIND_POSITION_PRO_TITLE.MAIN_FORCE, contents: '나는 날렵하며,<br> 달리기가 빠른 편이다.' },
                { key: 5, group_key: 2, title: FIND_POSITION_PRO_TITLE.ADVENTURE, contents: '나는 호기심이 많으며, 도전을<br> 걸어보거나 모험을 하는 것을 즐긴다.' },
                { key: 9, group_key: 3, title: FIND_POSITION_PRO_TITLE.CONFIDENCE, contents: '나는 내가 하는 행동의 결과를 믿고,<br>실패에 대한 두려움이 없는 등,<br>자신감이 높은 편이다.' },
                { key: 13, group_key: 4, title: FIND_POSITION_PRO_TITLE.THOUGHTFUL, contents: '나는 동료를 잘 챙기고, 골 양보를 하는 등<br> 배려심이 있는 편이다.' },
                { key: 2, group_key: 1, title: FIND_POSITION_PRO_TITLE.MAIN_FORCE, contents: '나는 현재 우리팀에서 빠른 편이다.', },
                { key: 6, group_key: 2, title: FIND_POSITION_PRO_TITLE.ADVENTURE, contents: '나는 (패스, 드리블, 슛의) 성공확률이<br> 높지 않더라도 자주 도전을 한다.', },
                { key: 10, group_key: 3, title: FIND_POSITION_PRO_TITLE.CONFIDENCE, contents: '나는 드리블을 할 때 수비에게 <br>두려움을 느낀 적이 없다.', },
                { key: 14, group_key: 4, title: FIND_POSITION_PRO_TITLE.THOUGHTFUL, contents: '나는 힘들어하는 팀원을 위해<br> 팀원의 역할까지 수행할 수 있다.', },
                { key: 3, group_key: 1, title: FIND_POSITION_PRO_TITLE.MAIN_FORCE, contents: '나는 속해있는 그룹 혹은 조직 <br>(회사, 학교 등)에서 속도가 빠른 편이다.', },
                { key: 7, group_key: 2, title: FIND_POSITION_PRO_TITLE.ADVENTURE, contents: '나는 코너킥으로 슛에 도전해본 적이 <br> 있거나 해볼 생각이 있다.', },
                { key: 11, group_key: 3, title: FIND_POSITION_PRO_TITLE.CONFIDENCE, contents: '나는 결정적인 순간 슛을 할 때<br> 골이 들어갈 것이라고 확신하곤 한다.', },
                { key: 15, group_key: 4, title: FIND_POSITION_PRO_TITLE.THOUGHTFUL, contents: '나는 포지션이 겹치는 동료가<br> 바꿔달라고 요청하면 들어주는 편이다.', },
                { key: 4, group_key: 1, title: FIND_POSITION_PRO_TITLE.MAIN_FORCE, contents: '나는 나보다 앞서있는 사람도<br> 따라잡을 자신이 있다.', },
                { key: 8, group_key: 2, title: FIND_POSITION_PRO_TITLE.ADVENTURE, contents: '나는 1대1 상황에서 패스보다는 <br>돌파를 하는 게 더 보람차다.', },
                { key: 12, group_key: 3, title: FIND_POSITION_PRO_TITLE.CONFIDENCE, contents: '나에게 패스가 온다면 즉시<br> 골로 연결시킬 수 있다고 생각한다.', },
                { key: 16, group_key: 4, title: FIND_POSITION_PRO_TITLE.THOUGHTFUL, contents: '나는 골을 넣는 것보다는<br> 어시스트를 더 선호하는 편이다.', },
                { key: 17, group_key: 5, title: FIND_POSITION_PRO_TITLE.HEALTH, contents: '나는 경기를 끝까지 뛸 수 있을 정도로<br> 기초 체력이 좋은 편이다.', },
                { key: 21, group_key: 6, title: FIND_POSITION_PRO_TITLE.BALL_CONTROL, contents: '나는 공에 대한 감각이 좋으며,<br> 볼 컨트롤이나 드리블 능력이 좋다.', },
                { key: 25, group_key: 7, title: FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT, contents: '나는 대체로 섬세한 편이며,<br> 패스와 크로스, 킥 등의 볼 전달<br> 능력이 좋은 편이다.', },
                { key: 29, group_key: 8, title: FIND_POSITION_PRO_TITLE.EYESIGHT, contents: '나는 시야가 넓은 편이며, 빈공간이나기회를 잘 옅볼 수 있다.', },
                { key: 18, group_key: 5, title: FIND_POSITION_PRO_TITLE.HEALTH, contents: '나는 내가 속한 그룹에서 오래 달리기를 하면 1등할 자신이 있다.', },
                { key: 22, group_key: 6, title: FIND_POSITION_PRO_TITLE.BALL_CONTROL, contents: '나는 내가 갖고 있는 공은 대체로 뺏기지 않는 편이다.', },
                { key: 26, group_key: 7, title: FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT, contents: '나는 빠르게 움직이는 상황에서도 원하는 방향으로 패스, 킥, 슛을 할 수 있다.', },
                { key: 30, group_key: 8, title: FIND_POSITION_PRO_TITLE.EYESIGHT, contents: '나는 정면을 바라봐도 좌, 우에서 벌어지는 움직임들을 포착할 수 있다.', },
                { key: 19, group_key: 5, title: FIND_POSITION_PRO_TITLE.HEALTH, contents: '나는 경기가 끝나도 크게 힘들거나 피로하지 않는다.', },
                { key: 23, group_key: 6, title: FIND_POSITION_PRO_TITLE.BALL_CONTROL, contents: '나는 예상 못한 견제를 받아도 공을 잘 지켜내는 편이다.', },
                { key: 44, group_key: 7, title: FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT, contents: '나는 프리킥 상황에서 90%이상의 확률로 골을 넣는다.', },
                { key: 31, group_key: 8, title: FIND_POSITION_PRO_TITLE.EYESIGHT, contents: '나는 평소에 팀원들에게 시야가 좋다는 소리를 자주 듣는다.', },
                { key: 20, group_key: 5, title: FIND_POSITION_PRO_TITLE.HEALTH, contents: '나는 평소에 체력이 좋다는 소리를 자주 듣는 편이다.', },
                { key: 24, group_key: 6, title: FIND_POSITION_PRO_TITLE.BALL_CONTROL, contents: '나는 1대1 상황에서 대체로 이길 수 있다고 생각한다.', },
                { key: 27, group_key: 7, title: FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT, contents: '나는 주변 사람들로부터 킥, 패스 능력이 좋다는 소리를 듣는 편이다.', },
                { key: 32, group_key: 8, title: FIND_POSITION_PRO_TITLE.EYESIGHT, contents: '나는 빈 공간이 있으면 길게 스루패스를 하는 것을 좋아한다.', },
                { key: 33, group_key: 9, title: FIND_POSITION_PRO_TITLE.GAME_FLOW, contents: '나는 문제상황과 기회를 잘 파악할 수 있으며 경기의 흐름을 잘 읽는다.', },
                { key: 28, group_key: 7, title: FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT, contents: '프리킥, 코너킥은 잘 차는 편이며, 주로 내가 전담 키커다.', },
                { key: 37, group_key: 10, title: FIND_POSITION_PRO_TITLE.RESPONSIBILITY, contents: '나는 내가 맡은 역할에 대해 애정과 책임감을 가지고 임하는 편이며,내 포지션의 역할을 놓치지 않고 수행한다.', },
                { key: 40, group_key: 11, title: FIND_POSITION_PRO_TITLE.HEIGHT, contents: '나는 내 주변에서나 내가 속한 팀에서 키가 큰 편이다.', },
                { key: 34, group_key: 9, title: FIND_POSITION_PRO_TITLE.GAME_FLOW, contents: '나는 체력적으로 정말 힘든 순간에도 팀의 승리 방법을 구상하곤 한다.', },
                { key: 38, group_key: 10, title: FIND_POSITION_PRO_TITLE.RESPONSIBILITY, contents: '나는 나로 인해 팀이 실점했을 경우 실점을 만회하기 위해 더 열심히 뛴다.', },
                { key: 41, group_key: 11, title: FIND_POSITION_PRO_TITLE.HEIGHT, contents: '나는 수비수와 공중볼 헤딩 경합에서굳이 점프를 하지 않아도 될 정도로키가 큰 편이다.', },
                { key: 39, group_key: 10, title: FIND_POSITION_PRO_TITLE.RESPONSIBILITY, contents: '나는 주변에서 책임감 있는 사람이라는 얘기를 자주 듣곤 한다.', },
                { key: 35, group_key: 9, title: FIND_POSITION_PRO_TITLE.GAME_FLOW, contents: '나는 축구 경기를 관전할 때도 경기흐름을 잘 파악하고 승부를 예측하여 맞추는 경우도 있다.', },
                { key: 42, group_key: 11, title: FIND_POSITION_PRO_TITLE.HEIGHT, contents: '나는 속해있는 그룹 혹은 조직 (회사, 학교 등)에서 키가 대체로 큰 편이다.', },
                { key: 36, group_key: 9, title: FIND_POSITION_PRO_TITLE.GAME_FLOW, contents: '나는 팀원들에게 경기흐름을 잘 읽는다는 칭찬을 자주 듣는다.', },
                { key: 43, group_key: 12, title: FIND_POSITION_PRO_TITLE.FOOT_WAY, contents: '내가 주로 사용하는 발은?', },
            ],
            sentenceCnt: 0,
            activeBtn: false,
            leftFoot: false,
            positions: [
            ],
            rightFoot: false,
            groupedData: [],
            isShowLanding: false
        }
    },
    created() {
        this.completeAndWait = this.$Once(this.completeAndWait)
        this.showResult = this.$Once(this.showResult)
        this.sentenceCnt = this.sentence.length - 1
    },
    methods: {
        showMemberRegist() {
            this.$GlobalStore.addModal('MemberTypeSelect', {
                isModalBackTransparent: true, transitionName: 'bottom', completeAction: (register_type) => {
                    this.$GlobalStore.addModal('MemberRegist', { transitionName: 'bottom', register_type: register_type, isLanding: this.isLanding });
                }
            })
        },
        prevStep() {
            this.step--
        },
        setScore(score, foot = false) {
            if (this.scores[this.step] === score) {
                this.$set(this.scores, this.step, 0)
            } else {
                this.$set(this.scores, this.step, score);
            }
            if (!foot && this.scores[this.step] !== 0) {
                this.activeBtn = true
            } else if (!foot && this.scores[this.step] === 0) {
                this.activeBtn = false
            }
        },
        validate() {
            if (this.scores[this.step] === 0) return false;
            return true;
        },
        async completeAndWait() {
            const formData = new FormData()
            formData.append('type', 'pro')

            await this.$Axios.post('/api/position/wait/save', formData)

        },
        async showResult() {
            // 1 하(그렇지않다) 2 중하 3 중 4 중상 5 상(그렇다)
            let score_infos = [];

            // let tt = true

            if (!this.leftFoot && !this.rightFoot) {
                this.$GlobalStore.showAlert('사용하는 발을 선택해주세요')
                return
            }

            this.$GlobalStore.showProgress()
            for (let i = 1; i < this.sentence.length; i++) {
                // // 테스트할때만 임의로
                // if (this.scores[i] === 0) {
                //     this.scores[i] = Math.floor(Math.random() * 5) + 1
                // }
                // if (this.sentence[i].key === undefined) {
                //     continue
                // }
                // 테스트할때만 임의로
                score_infos.push({
                    key: this.sentence[i].key,
                    group_key: this.sentence[i].group_key,
                    score: this.scores[i],
                    title: this.sentence[i].title
                });
            }
            const targetTitles = [
                FIND_POSITION_PRO_TITLE.HEALTH,
                FIND_POSITION_PRO_TITLE.MAIN_FORCE,
                FIND_POSITION_PRO_TITLE.BALL_CONTROL,
                FIND_POSITION_PRO_TITLE.EYESIGHT,
                FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT,
                FIND_POSITION_PRO_TITLE.FOOT_WAY
            ];

            const filteredData = score_infos.filter(item => targetTitles.includes(item.title));

            const groupedData = filteredData.reduce((result, item) => {
                const title = item.title;

                if (!result[title]) {
                    result[title] = 0;
                }

                result[title] += parseInt(item.score) || 0;

                return result;
            }, {});

            this.groupedData = groupedData

            // 포지션 프로 테스트할 떄
            // this.positions = [
            //     { position: 'WB', desc: 'WB' },
            // ]
            // this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: this.positions, groupedData: this.groupedData })
            // 포지션 프로 테스트할 떄
            const parameters = {};
            parameters.score_infos = JSON.stringify(score_infos);
            if (this.is_free) {
                parameters.is_free = this.is_free;
            }
            const res = await axios.post('/api/position/survey', parameters);

            if (res.data.code === ResponseCode.SUCCESS) {
                // this.completeAndWait()
                setTimeout(() => {
                    this.positions = res.data.positions;
                    const now = moment()
                    const saveProTime = now.format('YYYY-MM-DD HH:mm:ss')
                    const positionType = { lite: false, pro: true }
                    this.$GlobalStore.hideProgress()
                    localStorage.setItem('savePositionTimePro', saveProTime)
                    localStorage.setItem('POSITION_TYPE', JSON.stringify(positionType))
                    localStorage.setItem('positionArr', JSON.stringify(this.positions))
                    localStorage.setItem('groupData', JSON.stringify(this.groupedData))
                    const positionArr = JSON.parse(localStorage.getItem('positionArr'))
                    const groupedData = JSON.parse(localStorage.getItem('groupData'))
                    // this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: this.positions, groupedData: this.groupedData })
                    this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: positionArr, groupedData: groupedData, position_result_history_group_key: res.data.group_key })
                }, 1200);
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        next(step = 0) {
            if (step === 0) {
                this.activeBtn = false
            }

            if (this.step === 3 && this.isLanding) {
                this.isShowLanding = true
                return
            }

            if (this.step > 0 && this.step < (this.sentenceCnt - 1) && !this.validate()) {
                this.$GlobalStore.showAlert('항목을 선택해주세요.');
                return;
            }

            this.step++;
        },
        setFootScore(score) {
            if (score === 1) {
                this.leftFoot = !this.leftFoot
            } else if (score === 3) {
                this.rightFoot = !this.rightFoot
            }

            if (this.leftFoot || this.rightFoot) {
                this.activeBtn = true
            } else {
                this.activeBtn = false
            }

            if (this.leftFoot && this.rightFoot) {
                this.footScore = 2
            } else if (this.rightFoot) {
                this.footScore = 3
            } else if (this.leftFoot) {
                this.footScore = 1
            } else {
                this.footScore = 0
            }

            this.setScore(this.footScore, true)
        },
    }

}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.common_btn_survey {
    flex: 1;
    border-radius: 12px;
    border: 1px solid #d9d9d9;
    padding: 16px 8px;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 9.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.position_img_cont {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* grid-template-columns: repeat(2, 120px); */
    justify-content: center;
    margin-top: 70px;
    gap: 40px;
    flex: 1;
    align-items: center;
    padding: 40px;
}

.result_wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.common_btn {
    width: calc(100% - 40px);
    line-height: 50px;
    text-align: center;
    background-color: var(--color-main);
    border-radius: 6px;
    color: #fff;
    margin: 0 auto;
    margin-top: 20px;
}

.common_btn_round {
    margin: 0 auto;
    font-weight: 500;
    font-size: 20px;
    width: 240px;
    height: 47px;
    border-radius: 22.5px;
    line-height: 47px;
    border: 1px solid var(--color-main);
    text-align: center;
}

.on_bg_cl {
    background: linear-gradient(210deg, rgba(55, 236, 186, 0.9) 13.4%, rgba(117, 212, 115, 0.9) 86.6%);
}

.step1 {
    width: 325px;
    transform: scale(3.5);
    transition: transform 0.5s
}

.step2 {
    width: 325px;
    transform: scale(2.1);
    transition: transform 0.5s
}

.step3 {
    width: 325px;
    transform: scale(1.7);
    transition: transform 0.5s
}

.step4 {
    width: 325px;
    transform: scale(1);
    transition: transform 0.5s
}

.step5 {
    transform: rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents {
    transform: translateY(-112px) rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents_text {
    opacity: 1;
    transition: opacity .5s
}

.un_show_contents_text {
    opacity: 0;
}

.step1_ani1 {
    right: 17%;
    top: 42%;
}

.step1_ani2 {
    right: 53%;
    top: -53%;
}

.step1_ani3 {
    right: 117%;
    top: 220px;
}

.step1_ani4 {
    right: -56%;
    top: 186%;
}

.step1_ani5 {
    right: 33%;
    top: 223%;
}

.step1_ball {
    width: 28px;
    top: 30%;
    right: 39%;
}

.step2_ani1 {
    top: 20%;
    right: 2%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani3 {
    top: 50%;
    right: 95%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani4 {
    top: 91%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani5 {
    top: 143%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ball {
    width: 28px;
    top: -3%;
    right: 72%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.6);
}

.step3_ani1 {
    top: -44%;
    right: -17%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani3 {
    top: 22%;
    right: 106%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani4 {
    top: 27%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani5 {
    top: 96%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ball {
    width: 28px;
    top: -47%;
    right: 5%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step4_ani1 {
    top: -13%;
    right: 9%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end1 {
    top: -13%;
    right: 9%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani2 {
    top: -4%;
    right: 38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end2 {
    top: -4%;
    right: 38%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani3 {
    top: 11%;
    right: 76%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end3 {
    top: 11%;
    right: 76%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani4 {
    top: 22%;
    right: -20%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end4 {
    top: 22%;
    right: -20%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani5 {
    top: 75%;
    right: 30%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end5 {
    top: 75%;
    right: 30%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    opacity: 0;
    transition: top 1s, right 1s, transform 1s, opacity 1s;
    transform: scale(0.3);
}


.step1_circle {
    height: 60px;
    width: 60px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0px 4px 4px 0px #00000040;
    position: absolute;
}

.first_explain_wrap {
    padding: 15px 10px 20px 10px;
    text-align: center;
    background-color: #ffece1;
    border-radius: 5px;
}

.first_explain_wrap+.first_explain_wrap {
    margin-top: 10px;
}

.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
}

.round_wrap {
    position: relative;
    font-size: 0px;
}

.round {
    border-radius: 50%;
    background: #373C45;
}

.round_wrap+.round_wrap {
    margin-left: 21px;
}


.inner_round {
    width: 100%;
    height: 100%;
    display: none;
    background-color: blue;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-image: url('~@/assets/img/check_white.png');
    background-repeat: no-repeat;
    background-size: 22px;
    background-position: center center;
}

.orange_background {
    background-color: #345AA1;
}

.blue_background {
    background-color: #5f6cc3;
}

.active {
    background-color: var(--color-main);
}

.inner_round.active {
    display: block;
}

.black_background {
    background-color: black;
}

.next_btn {
    border-radius: 12px;
    flex-basis: 44%;
    background-color: var(--color-main);
    padding: 12px 0;
    line-height: 24px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
}

.result_btn {
    border-radius: 12px;
    height: 40px;
    background-color: #373C45;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 20px);
    color: #d9d9d9;
    font-weight: 500;
    margin-right: 20px;
    color: #fff;
    font-size: 14px;
    margin: 0 auto;
}

.prev_btn {
    flex-basis: 102px;
    flex-shrink: 0;
    height: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    font-size: 14px;
    background-color: #373C45;
    color: #fff;
    font-weight: 500;
}

/* 주력 */
.step_img_ani_unactive_주력 {
    transform: translateX(-60px)
}

.step_img_ani_active_주력 {
    transform: translateX(-44px)
}

.step_sub_img_ani_unactive_주력 {
    transform: translate(10px, -24px);
    width: 121px;
    height: 161px;
}

.step_sub_img_ani_active_주력 {
    transform: translate(40px, -24px);
    width: 171px;
    height: 161px;
}

/* 모험심 */
.step_img_ani_unactive_모험심 {
    transform: translateX(12px) scale(1);
}

.step_img_ani_active_모험심 {
    transform: translateX(-20px) scale(1.15);
}

.step_sub_img_ani_unactive_모험심 {
    transform: translate(64px, 8px);
    width: 0px;
}

.step_sub_img_ani_active_모험심 {
    transform: translate(64px, 8px);
    width: 50px;

}

/* 스탭 자신감 */
.step_img_ani_unactive_자신감 {
    transform: translateX(-83px) scale(0.85);
}

.step_img_ani_active_자신감 {
    transform: translateX(-82px) scale(0.95);
}

.step_sub_img_ani_unactive_자신감 {
    transform: translate(52px, -122px);
    opacity: 0;
}

.step_sub_img_ani_active_자신감 {
    transform: translate(52px, -122px);
    opacity: 1;

}

/* 배려심 */

.step_img_ani_unactive_배려심 {
    transform: translateX(-35px);
}

.step_img_ani_active_배려심 {
    transform: translateX(-35px) scale(0.8);
}

.step_sub_img_ani_unactive_배려심 {
    transform: translate(108px, -138px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active_배려심 {
    transform: translate(104px, -134px) rotate(-17deg) scale(0.7);
    position: relative;
    z-index: 10;

}

/* 체력 */
.step_img_ani_unactive_체력 {
    transform: translateX(0);
}

.step_img_ani_active_체력 {
    transform: translateX(30px);
}

.step_sub_img_ani_unactive_체력 {
    transform: translate(147px, 75px);
}

.step_sub_img_ani_active_체력 {
    transform: translate(176px, 77px) rotate(3deg);

}

.step_sub2_img_ani_unactive_체력 {
    transform: translate(-135px, 43px);
}

.step_sub2_img_ani_active_체력 {
    transform: translate(-97px, 53px) rotate(-20deg);

}

/* 공 제어 감각 */
.step_img_ani_unactive_공제어감각 {
    transform: translateX(69px);
}

.step_img_ani_active_공제어감각 {
    transform: translateX(69px) scale(1.1);
}

.step_sub_img_ani_unactive_공제어감각 {
    transform: translate(144px, 11px);
    opacity: 0;
}

.step_sub_img_ani_active_공제어감각 {
    transform: translate(144px, 11px);
    position: relative;
    z-index: 10;
    opacity: 1;
}

.step_sub2_img_ani_unactive_공제어감각 {
    transform: translate(-156px, -1px);
}

.step_sub2_img_ani_active_공제어감각 {
    transform: translate(-99px, -1px) scale(1.1);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive_공제어감각 {
    transform: translate(-64px, 64px);
}

.step_sub3_img_ani_active_공제어감각 {
    transform: translate(-55px, 71px) scale(1.1) rotate(-10deg);

}

.step_sub4_img_ani_unactive_공제어감각 {
    transform: translate(-191px, 43px);
}

.step_sub4_img_ani_active_공제어감각 {
    transform: translate(-207px, 38px) rotate(36deg);
}

/* 패스 킥 슛 */
.step_img_ani_unactive_패스킥슛 {
    transform: translate(92px, 15px);
}

.step_img_ani_active_패스킥슛 {
    transform: translate(96px, 11px);
}

.step_sub_img_ani_unactive_패스킥슛 {
    transform: translate(254px, -13px);
    opacity: 0;
}

.step_sub_img_ani_active_패스킥슛 {
    transform: translate(254px, -13px);
    opacity: 1;
}

.step_sub2_img_ani_unactive_패스킥슛 {
    transform: translate(-9px, 77px);
}

.step_sub2_img_ani_active_패스킥슛 {
    transform: translate(-11px, 70px) rotate(9deg);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive_패스킥슛 {
    transform: translate(-95px, -57px);
}

.step_sub3_img_ani_active_패스킥슛 {
    transform: translate(-93px, -66px) rotate(20deg)
}

.step_sub4_img_ani_unactive_패스킥슛 {
    transform: translate(-36px, -70px);
}

.step_sub4_img_ani_active_패스킥슛 {
    transform: translate(-29px, -68px) rotate(17deg);
}

.step_sub5_img_ani_unactive_패스킥슛 {
    transform: translate(-139px, 9px);
    position: relative;
    z-index: 10;
}

.step_sub5_img_ani_active_패스킥슛 {
    transform: translate(-102px, 7px) rotate(-20deg);
    position: relative;
    z-index: 10;
}

.step_sub6_img_ani_unactive_패스킥슛 {
    transform: translate(-172px, -10px);
}

.step_sub6_img_ani_active_패스킥슛 {
    transform: translate(-82px, -37px);
}

/* 시야 */

.step_img_ani_unactive_시야 {
    transform: translate(64px, 20px);
}

.step_img_ani_active_시야 {
    transform: translate(64px, 0px);
}

.step_sub_img_ani_unactive_시야 {
    transform: translate(31px, 5px);
    /* opacity: 0; */
}

.step_sub_img_ani_active_시야 {
    transform: translate(31px, 5px);
    opacity: 1;
}

.step_sub2_img_ani_unactive_시야 {

    transform: translate(56px, -12px);
    position: relative;
    z-index: 10;
}

.step_sub2_img_ani_active_시야 {
    transform: translate(-104px, -12px);
    position: relative;
    z-index: 10;

}

.step_sub3_img_ani_unactive_시야 {
    transform: translate(42px, -18px);
}

.step_sub3_img_ani_active_시야 {
    transform: translate(29px, -18px) rotate(40deg);

}

.step_sub4_img_ani_unactive_시야 {
    transform: translate(20px, -13px);
}

.step_sub4_img_ani_active_시야 {
    transform: translate(20px, -13px);
}

.step_sub5_img_ani_unactive_시야 {
    transform: translate(18px, 38px);
    position: relative;
    z-index: 10;
}

.step_sub5_img_ani_active_시야 {
    transform: translate(-16px, 38px);
    position: relative;
    z-index: 10;
}

/* 경기 흐름 */
.step_img_ani_unactive_경기흐름 {
    transform: rotateX(0deg);
}

.step_img_ani_active_경기흐름 {
    transform: rotateX(60deg);
}

/* 책임감 */

.step_img_ani_unactive_책임감 {
    transform: translate(-25px);
}

.step_img_ani_active_책임감 {
    transform: translate(-25px);
}

.step_sub_img_ani_unactive_책임감 {
    transform: translate(18px, -94px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active_책임감 {
    transform: translate(25px, -102px) rotate(-34deg);
    position: relative;
    z-index: 10;
}

/* 키 */
.step_img_ani_unactive_키 {
    transform: translate(45px, 60px) scale(0.9);
    position: relative;
    z-index: 15;
}

.step_img_ani_active_키 {
    transform: translate(45px, 66px) scale(1);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_unactive_키 {
    transform: translate(107px, -71px);
    position: relative;
    z-index: 10;
}

.step_sub_img_ani_active_키 {
    transform: translate(98px, -82px);
    position: relative;
    z-index: 15;
}

.step_sub2_img_ani_unactive_키 {
    transform: translate(-46px, -43px);
    position: relative;
    z-index: 5;
}

.step_sub2_img_ani_active_키 {
    transform: translate(-71px, -59px) rotate(34deg);
    position: relative;
    z-index: 5;
}

@media (max-width: 500px) {

    /* 여기에 원하는 스타일 적용 */
    .common_btn_survey {
        min-height: 52px;
        padding: 0;
    }
}
</style>